import { loginApiPaths } from '@/includes/api/auth/constants';
export var LOGIN_TYPE;
(function (LOGIN_TYPE) {
    LOGIN_TYPE["INTERNAL"] = "INTERNAL";
    LOGIN_TYPE["EXTERNAL"] = "EXTERNAL";
})(LOGIN_TYPE || (LOGIN_TYPE = {}));
export const UNAUTHENTICATED_ENDPOINTS = [loginApiPaths.signInWithOTP];
